import { render } from "./DeleteScoutForm.vue?vue&type=template&id=6b710ed0"
import script from "./DeleteScoutForm.vue?vue&type=script&lang=js"
export * from "./DeleteScoutForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__